const TelegramIcon: React.FC = () => (
  <svg
    viewBox="0 0 29 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.44 16.0952L22.04 6.19048L7.65117 15.2219L1.03371 13.051C-0.389965 12.587 -0.397875 11.5409 1.35272 10.7901L27.0132 0.216722C28.5027 -0.430052 29.3464 0.388256 28.8639 2.43825L24.4954 24.4285C24.1895 25.9949 23.3063 26.3689 22.0804 25.6462L15.3548 20.337L12.2201 23.5652C11.8985 23.8971 11.6375 24.1811 11.1418 24.2514C10.6488 24.3245 10.2428 24.167 9.94487 23.2953L7.65117 15.2219L10.44 16.0952Z"
      fill="white"
    />
  </svg>
);

export default TelegramIcon;
